import React from 'react';

import { IconProps, StyledPath, StyledSvg } from '../iconCommons';

export const IconEnvelop = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" size={size} {...props}>
        <StyledPath
            d="M11.084 13.3L6 18M1 6H31V26H1V6ZM20.916 13.3L26 18L20.916 13.3Z"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
            strokeWidth="1.5"
        />
        <StyledPath
            d="M30.5066 6.68533L17.8226 15.432C17.2868 15.8019 16.6511 16.0001 16 16.0001C15.3488 16.0001 14.7131 15.8019 14.1773 15.432L1.49329 6.68533"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            color="none"
            strokeWidth="1.5"
        />
    </StyledSvg>
);
